// extracted by mini-css-extract-plugin
export default {"addressSection":"H1-z","disabled":"I1-z","sectionButtons":"J1-z","logo":"K1-z"};